import React, { PropTypes } from 'react';
import DatePicker from 'react-datepicker';
import { Col, ControlLabel, FormGroup } from 'react-bootstrap';
import { momentSetHKTimezone } from '../../../../utils/dateUtils';

const IssueDate = (props) => {
  return (
      <FormGroup controlId="startEndDate">
        <Col sm={6}>
          <FormGroup controlId="issueDateFrom">
            <Col componentClass={ControlLabel} sm={4}>
              {props.startDateLabel}
            </Col>
            <Col sm={8}>
               <DatePicker
                  id="startDate"
                  placeholderText="DD/MM/YYYY"
                  dateFormat="DD/MM/YYYY"
                  todayButton={'Today'}
                  autoComplete="off"
                  selected={props.startDate != null ? momentSetHKTimezone(props.startDate) : null}
                  onChange={props.handleChangeStartDate}
                  />
            </Col>
          </FormGroup>
        </Col>
        <Col sm={6}>
          <FormGroup controlId="issueDateFrom">
            <Col componentClass={ControlLabel} sm={4}>
              {props.endDateLabel}
            </Col>
            <Col sm={8}>
               <DatePicker
                  placeholderText="DD/MM/YYYY"
                  dateFormat="DD/MM/YYYY"
                  todayButton={'Today'}
                  autoComplete="off"
                  selected={props.endDate != null ? momentSetHKTimezone(props.endDate) : null}
                  onChange={props.handleChangeEndDate}
                  />
            </Col>
          </FormGroup>
        </Col>
      </FormGroup>
  )
}

IssueDate.propTypes = {
  startDate: PropTypes.string,
  endDate: PropTypes.string,
  startDateLabel: PropTypes.string,
  endDateLabel: PropTypes.string,
  handleChangeStartDate: PropTypes.func,
  handleChangeEndDate: PropTypes.func
};

export default IssueDate;



// WEBPACK FOOTER //
// ./src/app/components/retrieveCoverNoteComponent/issueDate/IssueDate.js